import { render, staticRenderFns } from "./NewHeaderItem.vue?vue&type=template&id=4ed13eb0&scoped=true&"
import script from "./NewHeaderItem.vue?vue&type=script&lang=ts&"
export * from "./NewHeaderItem.vue?vue&type=script&lang=ts&"
import style0 from "./NewHeaderItem.vue?vue&type=style&index=0&id=4ed13eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed13eb0",
  null
  
)

export default component.exports